module.exports = __webpack_public_path__ + "static/w1-b7a0ea0fc5f5ed1954a89c465e6be42c.jpg";